'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createAction = exports.actionTypes = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.isPollingAction = isPollingAction;
exports.createPollingActions = createPollingActions;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actionTypes = exports.actionTypes = {
    start: '@POLLING_STATE/START',
    stop: '@POLLING_STATE/STOP',
    reset: '@POLLING_STATE/RESET',
    request: '@POLLING_STATE/REQUEST',
    addEntries: '@POLLING_STATE/ADD_ENTRIES'
};

function isObject(obj) {
    return (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && obj !== null;
}

var createAction = exports.createAction = function createAction(type, meta, payload) {
    return { type: type, meta: meta, payload: payload };
};
var createActionCreator = function createActionCreator(type, meta) {
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return createAction(type, meta, [].concat(args));
    };
};

function isPollingAction(action) {
    return !!(Object.values(actionTypes).indexOf(action.type) > -1 && action.meta && action.meta.pollingName);
}

function createPollingActions(pollingName, callbacks) {
    var pollingInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
    var historyLimit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    if (!isObject(callbacks)) {
        /* eslint-disable-next-line no-param-reassign */
        callbacks = { polling: callbacks };
    }

    if (typeof pollingName !== 'string') {
        throw new Error('pollingName is required and must be a string');
    }

    if (typeof callbacks.polling !== 'function') {
        throw new Error('polling method is required and must be a function');
    }

    var meta = {
        pollingName: pollingName,
        callbacks: callbacks,
        pollingInterval: pollingInterval,
        historyLimit: historyLimit
    };

    return {
        start: createActionCreator(actionTypes.start, meta),
        stop: createActionCreator(actionTypes.stop, meta),
        reset: createActionCreator(actionTypes.reset, meta)
    };
}


//////////////////
// WEBPACK FOOTER
// ../dist/actions.js
// module id = 90
// module chunks = 0